import React from 'react';
import {
  Box,
  Button,
  LinearProgress,
  Paper,
  Typography,
  CircularProgress,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

export default function WizardShell({
  step,
  totalSteps,
  stepTitle,
  children,
  onBack,
  onNext,
  nextLabel = 'Seuraava',
  nextDisabled = false,
  loading = false,
  error = null,
}) {
  const progress = (step / totalSteps) * 100;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 }}>
      <Box sx={{ flex: 1, px: 2, pt: 1.5, pb: 2, overflowY: 'auto' }}>
        <Paper
          elevation={0}
          sx={(theme) => ({
            p: 2.5,
            bgcolor: theme.palette.mobile?.surface ?? theme.palette.background.paper,
            border: 1,
            borderColor: 'divider',
            borderRadius: 2,
          })}
        >
          {children}
        </Paper>
        {error && (
          <Typography color="error" variant="body2" sx={{ mt: 2 }}>
            {error}
          </Typography>
        )}
      </Box>

      <Box
        sx={{
          position: 'sticky',
          bottom: 0,
          px: 2,
          pt: 1.5,
          py: 2,
          pb: 'max(16px, env(safe-area-inset-bottom))',
          bgcolor: 'background.default',
          borderTop: 1,
          borderColor: 'divider',
          zIndex: 2,
        }}
      >
        <Box sx={{ mb: 1.5 }} aria-label={`Vaihe ${step}: ${stepTitle}`}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'baseline',
              justifyContent: 'space-between',
              gap: 1,
              mb: 0.75,
            }}
          >
            <Typography variant="body1" sx={{ fontWeight: 600, lineHeight: 1.3 }}>
              {stepTitle}
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ whiteSpace: 'nowrap' }}>
              {step} / {totalSteps}
            </Typography>
          </Box>
          <LinearProgress
            variant="determinate"
            value={progress}
            sx={{
              height: 3,
              borderRadius: 2,
              bgcolor: 'divider',
              '& .MuiLinearProgress-bar': { bgcolor: 'secondary.main' },
            }}
          />
        </Box>

        <Box sx={{ display: 'flex', gap: 1 }}>
          {step > 1 && (
            <Button
              variant="outlined"
              color="secondary"
              onClick={onBack}
              startIcon={<ArrowBackIcon />}
              sx={{ minWidth: 48, minHeight: 52, flex: '0 0 auto', px: 2 }}
            >
              Takaisin
            </Button>
          )}
          <Button
            variant="contained"
            color="primary"
            fullWidth
            onClick={onNext}
            disabled={nextDisabled || loading}
            sx={{ minHeight: 52 }}
          >
            {loading ? <CircularProgress size={24} color="inherit" /> : nextLabel}
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
